<script setup lang="ts">
import UiExpander from '@/components/UiExpander/UiExpander.vue'
</script>

<template>
  <div class="directSalesRodo">
    <div
      v-html="$t('wellbeing.form.rodo.notExpand')"
    />

    <UiExpander
      class="directSalesRodo__button"
      :text-to-show="$t('form.more')"
      :text-to-hide="$t('form.less')"
    >
      <div
        class="directSalesRodo"
        v-html="$t('wellbeing.form.rodo.expand')"
      />
    </UiExpander>
  </div>
</template>

<style lang="scss" scoped>

.directSalesRodo {
  margin-top: 2.4rem;
  color: $text-300;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 2.4rem;

  &__button {
    margin-top: .8rem;
  }

  :deep() {
    b {
      font-weight: bold;
    }

    a {
      color: $blue-400;
    }
  }

  :deep(.uiExpander__button) {
    padding: 0;
  }
}
</style>
